import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { ALL_USERS } from '../get-all-users';
import { resendInvitationAPI } from './api';

export function useResendInvitation({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (email) => resendInvitationAPI(email),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'resendInvitationSuccess',
          },
        });
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'resendInvitationError',
          },
        });
      },
    },
  );

  return {
    resendInvitation: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
